import { createApi } from "@reduxjs/toolkit/dist/query/react";
// import { defautBaseQuery } from "../../utils/API/fetchBaseQuery";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../utils/API/responseMiddleware";

const candidateInteractionAPI = createApi({
    reducerPath: 'candidateInteractionAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        //** Add  API */ 
        addIntraction: builder.mutation({
            query: (Details) => ({
                url: '/CandidateInteraction/AddCandidateInteraction',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getCandidateInteraction: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CandidateInteraction/GetCandidateInteractionDetails/?id=${Number(id)}`),
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllInterviewRound: builder.query({
            query: () => ({
                url: '/CandidateInteraction/GetAllInterviewRound',
                method: 'GET'
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addEditComment: builder.mutation({
            query: (Details) => ({
                url: '/CandidateInteraction/AddEditComment',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {
    useAddIntractionMutation, useLazyGetCandidateInteractionQuery , useLazyGetAllInterviewRoundQuery,useAddEditCommentMutation
} = candidateInteractionAPI

export default candidateInteractionAPI;